<template>
  <div class="pillars-navigation">
    <router-link to="/reports/gender-gap" class="back-button">
      <icon name="arrow-left" class="submenu-icon" scale="1.5" />
    </router-link>
    <ul>
      <li
        v-for="(section, sectionIndex) in pillarsIds"
        :key="sectionIndex"
        v-b-tooltip.hover
        :class="[
          getColorStateIndex(
            pillarData(section).index,
            pillarData(section).errorOnAllIndexIndicators
          ),
          section === pillarId ? 'selected' : '',
        ]"
        :title="$t('label_indicator_pillar_' + section + '_name')"
      >
        <router-link :to="'/reports/gender-gap/' + section">
          {{ $t("label_indicator_pillar_" + section + "_acronym") }}
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TemplateIndicatorNavigator",
  props: {
    pillarId: {
      type: String,
      default: "OP",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters(["pillarsIds", "pillarData", "getColorStateIndex"]),
  },
};
</script>
<style lang="sass" scoped>

/* components/template/template-pillar-navigator */
@import "../../assets/css/variables.scss"

.pillars-navigation
  text-align: center
  font-size: 1.2rem
  display: flex
  justify-content: center
  align-items: center
  font-family: $font-subtitle
  .back-button
    color: #676767
    border: 3px solid #676767
    border-radius: 50%
    width: 40px
    height: 40px
    display: flex
    justify-content: center
    align-items: center
    margin-right: 50px
  ul
    display: flex
    padding: 0px
    justify-content: center
    margin-top: 20px
    li
      list-style: none
      width: 62px
      height: 62px
      border-radius: 50%
      display: flex
      justify-content: center
      align-items: center
      position: relative
      margin: 0 17px
      &.selected
        width: 67px
        height: 67px
        border: 3px #fff solid
        top: -3px
        font-size: 1.4rem
        &:before
          content: " "
          position: absolute
          z-index: -1
          top: -10px
          left: -10px
          right: -10px
          bottom: -10px
          border: 8px solid #000
          border-radius: 50%
      &:after
        content: ''
        position: absolute
        display: block
        background: #8a8989
        width: 100%
        height: 1px
        left: 100%
        z-index: -10
      &:last-child:after
        display: none
      a
        text-decoration: none
        color: #fff
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center

.intermediate a
  color: #000 !important



@media (max-width: 768px)
  .pillars-navigation
    font-size: 1rem
    .back-button
      margin-right: 20px
    ul li
      width: 45px
      height: 45px
      margin: 0 10px
      &.selected
        width: 55px
        height: 55px
        top: -5px
        font-size: 1.2rem

@media (max-width: 540px)
  .pillars-navigation
    font-size: 0.8rem
    .back-button
      margin-right: 10px
    ul li
      width: 35px
      height: 35px
      margin: 0 2px
      &.selected
        width: 40px
        height: 40px
        top: -2px
        font-size: 1rem
        border: 1px #fff solid
        &:before
          top: -4px
          left: -4px
          right: -4px
          bottom: -4px
</style>
